import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { classNames } from 'utils/classNames';

import { SuiContainer, SuiTabs, SuiTab } from '@splashthat/sui';

import PaintBucket from 'common/icons/PaintBucket';
import Layout from 'common/icons/Layout';

import { getCanUserViewThemesDashboard } from 'common/store/permissions';

import './styles.styl';

const TAB_LAYOUT = 'content';
const TAB_DESIGN = 'theme';
const LABEL_LAYOUT = 'Layout';
const LABEL_DESIGN = 'Theme';

const BASE_CLASS_NAME = 'CmsSidebarTabs';

const CmsSidebarTabs = ({ className, currentTab, onChange }) => {
    const classNameList = classNames({
        [BASE_CLASS_NAME]: true,
        [className]: true,
    });
    const canViewThemesDashboard = useSelector(getCanUserViewThemesDashboard);

    return (
        <SuiContainer className={classNameList} variation="flex-horizontal-centered standard">
            <SuiTabs
                className={`${BASE_CLASS_NAME}__tabs`}
                onChange={(ev, value) => onChange(value)}
                value={currentTab}
                size="small"
            >
                <SuiTab
                    data-qa={`${BASE_CLASS_NAME}--qa-${TAB_LAYOUT}`}
                    key={TAB_LAYOUT}
                    value={TAB_LAYOUT}
                    label={LABEL_LAYOUT}
                    iconBefore={Layout}
                    iconDirection="column"
                    title={LABEL_LAYOUT}
                />
                <SuiTab
                    data-qa={`${BASE_CLASS_NAME}--qa-${TAB_DESIGN}`}
                    key={TAB_DESIGN}
                    value={TAB_DESIGN}
                    label={LABEL_DESIGN}
                    iconBefore={PaintBucket}
                    iconDirection="column"
                    title={LABEL_DESIGN}
                    disabled={!canViewThemesDashboard}
                />
            </SuiTabs>
        </SuiContainer>
    );
};

CmsSidebarTabs.propTypes = {
    currentTab: PropTypes.oneOf([TAB_LAYOUT, TAB_DESIGN]),
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

CmsSidebarTabs.defaultProps = {
    className: null,
    currentTab: null,
};

export { TAB_DESIGN, TAB_LAYOUT };

export default CmsSidebarTabs;
